import { LS_STATE_TAG, URL_STATE_TAG } from 'app/main/MainService';
import { AppStateProvider, simpleEffect } from 'app/shared/app_state/AppStateProvider';
import { urlParamVal, urlParamValEq } from 'app/shared/url_and_history/url_and_history';
import { isBool } from 'app/shared/utilities/validation';

const k_CENTER_COLLAPSED = 'center_collapsed';
const k_SHOW_OVERVIEW = 'show_overview_pane';
const k_SHOW_MAP = 'show_map_pane';
const k_SHOW_LICENSE_BANNER = 'show_license_banner';
const k_SHOW_EDITOR_BANNER = 'show_editor_banner';
const k_SHOW_MAP_POSITION_BANNER = 'show_map_position_banner';
const k_SHOW_MAP_BOUNDARIES_BANNER = 'show_map_boundaries_banner';

export class AgriculturePanesService {
    state: AppStateProvider;

    constructor(mainService) {
        // make sure they both don't initialise as false

        this.state = new AppStateProvider({
            keys: {
                [k_CENTER_COLLAPSED]: {
                    initialValue: true,
                    defaultValue: true,
                    validator: isBool,
                    tags: [LS_STATE_TAG],
                },
                [k_SHOW_OVERVIEW]: {
                    initialValue: false,
                    defaultValue: urlParamVal(false),
                    validator: isBool,
                    eqCheck: urlParamValEq,
                    tags: [URL_STATE_TAG],
                },
                [k_SHOW_MAP]: {
                    initialValue: true,
                    defaultValue: urlParamVal(true),
                    validator: isBool,
                    eqCheck: urlParamValEq,
                    tags: [URL_STATE_TAG],
                },
                [k_SHOW_LICENSE_BANNER]: {
                    initialValue: false,
                    defaultValue: urlParamVal(true),
                    validator: isBool,
                    eqCheck: urlParamValEq,
                    //Leave tags empty to remove from address url
                    tags: [],
                },
                [k_SHOW_EDITOR_BANNER]: {
                    initialValue: false,
                    defaultValue: urlParamVal(false),
                    validator: isBool,
                    eqCheck: urlParamValEq,
                    tags: [],
                },
                [k_SHOW_MAP_POSITION_BANNER]: {
                    initialValue: false,
                    defaultValue: urlParamVal(false),
                    validator: isBool,
                    eqCheck: urlParamValEq,
                    tags: [],
                },
                [k_SHOW_MAP_BOUNDARIES_BANNER]: {
                    initialValue: false,
                    defaultValue: urlParamVal(false),
                    validator: isBool,
                    eqCheck: urlParamValEq,
                    tags: [],
                },
            },
            effects: {
                toggleCenterCollapsed: simpleEffect((state, bool) => ({
                    [k_CENTER_COLLAPSED]: !state[k_CENTER_COLLAPSED],
                })),
                setShowLicenseBanner: simpleEffect((_changes, bool) => ({
                    [k_SHOW_LICENSE_BANNER]: bool,
                })),
                setShowEditorBanner: simpleEffect((_changes, bool) => ({
                    [k_SHOW_EDITOR_BANNER]: bool,
                })),
                setShowMapPositionBanner: simpleEffect((_changes, bool) => ({
                    [k_SHOW_MAP_POSITION_BANNER]: bool,
                })),
                setShowBoundariesBanner: simpleEffect((_changes, bool) => ({
                    [k_SHOW_MAP_BOUNDARIES_BANNER]: bool,
                })),
                setVisiblePanes: simpleEffect((_, changes) =>
                    Object.assign(
                        {},
                        changes[k_SHOW_MAP] !== undefined
                            ? { [k_SHOW_MAP]: changes[k_SHOW_MAP] }
                            : {},
                        changes[k_SHOW_OVERVIEW] !== undefined
                            ? { [k_SHOW_OVERVIEW]: changes[k_SHOW_OVERVIEW] }
                            : {},
                    ),
                ),
            },
            parent: mainService.state,
        });
    }

    showMap() {}

    showOverview() {}

    showBoth() {}

    initialisePanesCSS() {}

    public setVisiblePanes(effectArgs: Record<string, boolean>): void {}

    public getPanesState(): Record<string, boolean> {
        return {
            [k_SHOW_MAP]: this.state.getState()[k_SHOW_MAP],
            [k_SHOW_OVERVIEW]: this.state.getState()[k_SHOW_MAP],
            [k_SHOW_LICENSE_BANNER]: this.state.getState()[k_SHOW_LICENSE_BANNER],
            [k_SHOW_EDITOR_BANNER]: this.state.getState()[k_SHOW_EDITOR_BANNER],
            [k_SHOW_MAP_POSITION_BANNER]: this.state.getState()[k_SHOW_MAP_POSITION_BANNER],
            [k_SHOW_MAP_BOUNDARIES_BANNER]: this.state.getState()[k_SHOW_MAP_BOUNDARIES_BANNER],
        };
    }
}
